module.exports =
  IN_PROGRESS_STATUS: 'in progress'
  PLACING_AN_ORDER_GROUP: 'placing_an_order'
